import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UsersTransactionsStatistic')
export class UsersTransactionsStatistic {

  @JsonProperty('day_timestamp', Number)
  dayTimestamp: number = 0;

  @JsonProperty('free_credits_count', Number)
  freeCreditsCount: number = 0;

  @JsonProperty('league_reward_count', Number)
  leagueRewardCount: number = 0;

  @JsonProperty('mission_reward_count', Number)
  missionRewardCount: number = 0;

  @JsonProperty('tournament_reward_count', Number)
  tournamentRewardCount: number = 0;

  @JsonProperty('level_reward_count', Number)
  levelRewardCount: number = 0;

  @JsonProperty('news_count', Number)
  newsCount: number = 0;
}
